/**
 * SEO config and route meta for Watt Tower marketing site.
 * Canonical domain: https://www.watttower.com
 * SPA: meta is set per-route via react-helmet-async.
 */

export const SEO_BASE_URL = "https://www.watttower.com";
export const DEFAULT_OG_IMAGE = `${SEO_BASE_URL}/watt-tower-logo-transparent.png`;

export interface RouteMeta {
  title: string;
  description: string;
  canonicalPath: string;
  noindex?: boolean;
}

/** Title 55–60 chars; description 150–160 chars. */
export const ROUTE_META: Record<string, RouteMeta> = {
  "/": {
    title: "Solar Fleet Monitoring for Installers | Watt Tower",
    description:
      "Monitor, forecast, and optimize residential solar and battery systems at scale. Solar fleet dashboard, overnight reserve risk, Sol-Ark & EG4.",
    canonicalPath: "/",
  },
  "/terms": {
    title: "Terms of Service | Watt Tower",
    description:
      "Watt Tower Terms of Service. Acceptance, service description, eligibility, forecasts and alerts, messaging terms, and contact.",
    canonicalPath: "/terms",
  },
  "/privacy": {
    title: "Privacy Policy | Watt Tower",
    description:
      "Watt Tower Privacy Policy. How we collect, use, and protect your data. Account, telemetry, messaging, and your rights.",
    canonicalPath: "/privacy",
  },
  "/login": {
    title: "Sign In | Watt Tower",
    description: "Sign in to Watt Tower. Solar fleet monitoring and installer dashboard for residential solar and battery systems.",
    canonicalPath: "/login",
    noindex: true,
  },
  "/solar-monitoring-software-for-installers": {
    title: "Solar Monitoring Software for Installers | Watt Tower",
    description:
      "Solar monitoring software for installers: fleet visibility, battery forecasting, overnight reserve risk. Built for Sol-Ark and hybrid systems.",
    canonicalPath: "/solar-monitoring-software-for-installers",
  },
  "/solar-fleet-dashboard": {
    title: "Solar Fleet Dashboard | Multi-Site Monitoring | Watt Tower",
    description:
      "Solar fleet dashboard for installers. One view across every system: status, overnight risk, battery health. Sol-Ark, EG4, SolarEdge.",
    canonicalPath: "/solar-fleet-dashboard",
  },
  "/battery-backup-monitoring": {
    title: "Battery Backup Monitoring Software | Watt Tower",
    description:
      "Residential battery monitoring software. Capacity tracking, health scores, overnight reserve forecasting. For installers managing fleet systems.",
    canonicalPath: "/battery-backup-monitoring",
  },
  "/solar-forecasting-software": {
    title: "Solar Forecasting Software for Installers | Watt Tower",
    description:
      "Solar forecasting software: projected kWh at sunrise, confidence bands, overnight reserve risk. Fleet-level at-risk flags for installers.",
    canonicalPath: "/solar-forecasting-software",
  },
};

export function getCanonicalUrl(path: string): string {
  const base = path.startsWith("/") ? path : `/${path}`;
  return `${SEO_BASE_URL}${base}`;
}

export function getOgImageUrl(path?: string): string {
  return DEFAULT_OG_IMAGE;
}
